export const LIVESTATUS = {
  PREVIEW: 1,
  LIVE: 2,
  VIDEO: 4
}
export const LIVESOURCE = {
  AGORA: 1, // 声网
  // TAOBAO: 2, // 淘宝
  // ALIYUN: 3 // 阿里云
  
  //@todo 220712修改 source = 3 用artc，source=2用hls，source=1用声网
  ALIYUN: 2,
  ARTC: 3
}
export const LIVEMSGSOURCE = {
  LIVE_MSG_SOURCE_OF_APP: 1, // app
  LIVE_MSG_SOURCE_OF_WEAPP: 2, // 小程序
  LIVE_MSG_SOURCE_OF_BMS: 3, // 后台
  LIVE_MSG_SOURCE_OF_TAOBAO: 4, // 淘宝
  LIVE_MSG_SOURCE_OF_H5: 6 // H5
};

// 声网APPID
export const AGORA_APPID = 'dac19cb04202499a8ee5ca1f7085d0ff'

export const SCHEMEBASE = 'shopshopsng://shopshops.top:8080/openOfH5'